import {
  DiscordCategory,
  Platform,
  PrismaClient,
  TriggerStep,
} from "@prisma/client";
import { DiscordCategoryCreate, TriggerCreate } from "../../libs/types/src";

const workspace = "1cdef489-88af-47ff-9190-404b9d10fda9";
const communityId = "685243210829922350";

export const quicknodeProdCategory: DiscordCategoryCreate[] = [
  {
    name: "Dots-onboarding",
    type: "onboarding",
    guild: communityId,
    categoryId: "959447167666380883",
    workspace: workspace,
  },
  {
    name: "Dots-onboarding-2",
    type: "onboarding",
    guild: communityId,
    categoryId: "959447168492666881",
    workspace: workspace,
  },
];

const stepCommon: {
  platform: Platform;
  communityId: string;
  workspace: string;
} = {
  platform: "discord",
  communityId,
  workspace,
};
export const quicknodeProdTrigger: TriggerCreate = {
  platform: "discord",
  communityId,
  name: "Quicknode onboarding flow",
  workspace,
  authorUserId: "105403805100736512",
  type: "team_join",
  steps: [
    {
      ...stepCommon,
      id: "qn-step0",
      type: "create_channel",
      configs: {
        channelName: "onboard-{{user.username}}",
        userIds: ["{{user.id}}", "105403805100736512"],
        isPrivate: true,
        channelType: "onboarding",
      },
      transitions: [
        { targetStepId: "qn-step0a" },
        { targetStepId: "qn-delete" },
        { targetStepId: "qn-remind" },
        { targetStepId: `qn-send-dm` },
      ],
    },
    {
      ...stepCommon,
      id: "qn-step0a",
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["await-onboarding"],
      },
      transitions: [{ targetStepId: "qn-step1" }],
    },
    {
      id: `qn-delete`,
      type: "delete_channel",
      configs: {
        delaySeconds: 60 * 60 * 12,
        channelId: `{{qn-step0.channelId}}`,
      },
      transitions: [{ targetStepId: `qn-kick-member` }],
    },
    {
      id: `qn-remind`,
      type: "send_message",
      configs: {
        delaySeconds: 60 * 60 * 6,
        message:
          "Hey <@{{user.id}}>! You haven't quite finished onboarding process. This chat will close within 12 hours.",
        channelId: `{{qn-step0.channelId}}`,
      },
      transitions: [],
    },
    {
      id: `qn-send-dm`,
      type: "send_direct_message",
      configs: {
        userId: "{{user.id}}",
        message: `Hey <@{{user.id}}> This is the Quicknode Community Welcome bot. Hello 👋 Please finish the onboarding process in the private channel that we have created for you in the server! \nIf you don't finish the process in 12 hours, you will be automatically kicked out. If you want to rejoin our server, please use this link and make sure to complete the onboarding process within 12 hours -> https://discord.com/invite/DkdgEqE"`,
      },
      transitions: [],
    },
    {
      id: `qn-kick-member`,
      type: "kick_member",
      configs: {
        reason: `Didn't finish onboarding process`,
        userId: "{{user.id}}",
      },
      transitions: [],
    },
    {
      ...stepCommon,
      id: "qn-step1",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: `Hello <@{{user.id}}>, welcome! Please meet your community manager, Nick, who is also in this channel. \n What's your first name?`,
      },
      transitions: [
        {
          targetStepId: "qn-step1b",
          when: {
            userResponse: {
              type: "message",
              channelId: "{{qn-step0.channelId}}",
              userId: "{{user.id}}",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: "qn-step1b",
      type: "send_survey",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: `Nice to meet you, {{qn-step1.response.content}}! Would you like to receive updates from us via email?`,
        type: "buttons", // by default it's "emojis"
        options: [
          { emoji: "✅", id: "yes", label: "Yes" },
          { emoji: "❌", id: "no", label: "No" },
        ],
      },
      transitions: [
        {
          targetStepId: "qn-step2",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step1b.messageId}}",
              buttonId: "yes",
            },
          },
        },
        {
          targetStepId: "qn-step3",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step1b.messageId}}",
              buttonId: "no",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: "qn-step2",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: `Awesome! What's your email address?`,
      },
      transitions: [
        {
          targetStepId: "qn-step3",
          when: {
            userResponse: {
              type: "message",
              channelId: "{{qn-step0.channelId}}",
              userId: "{{user.id}}",
              content: {
                // Test if it's an email address: /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/
                regex: "[^@ \\t\\r\\n]+@[^@ \\t\\r\\n]+.[^@ \\t\\r\\n]+",
              },
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: "qn-step3",
      type: "send_survey",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        type: "buttons",
        message: `What brings you here, {{qn-step1.response.content}}? `,
        options: [
          { emoji: "🎓", id: "learn", label: "Learn" },
          { emoji: "👀", id: "see", label: "See what others are building" },
          { emoji: "💻", id: "troubleshooting", label: "Troubleshoot" },
        ],
      },
      transitions: [
        {
          targetStepId: "qn-step3-student-eth-role",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step3.messageId}}",
              buttonId: "learn",
            },
          },
        },
        {
          targetStepId: "qn-step3-see-others",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step3.messageId}}",
              buttonId: "see",
            },
          },
        },
        {
          targetStepId: "qn-step3-troubleshoot",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step3.messageId}}",
              buttonId: "troubleshooting",
            },
          },
        },
      ],
    },

    {
      ...stepCommon,
      id: "qn-step3-student-eth-role",
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Eth Dev"],
      },
      transitions: [{ targetStepId: "qn-step3-student" }],
    },

    {
      ...stepCommon,
      id: "qn-step3-student",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: `Amazing! You should see a channel <#945795361040121857> on the left with all the information about the official QuickNode Discord!\n\nPS: Did you know we have an education curriculum where you can learn about different chains we support? You can also check out the <#1009853072916353105> channel for more info!`,
      },
      transitions: [{ targetStepId: "qn-step4" }],
    },
    {
      ...stepCommon,
      id: "qn-step3-see-others",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: `Amazing! You should see a channel <#945795361040121857> on the left with all the information about the official QuickNode Discord!\n\nYou can also check out the <#918583224932900955> channel to get updates on news, outages, and upgrades. 
            `,
      },
      transitions: [{ targetStepId: "qn-step4" }],
    },
    {
      ...stepCommon,
      id: "qn-step3-troubleshoot",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message:
          "Amazing! You should see a channel <#945795361040121857> on the left with all the information about the official QuickNode Discord!\n\nYou can also check out the <#918583224932900955> channel to get updates on news, outages, and upgrades.",
      },
      transitions: [{ targetStepId: "qn-step4" }],
    },
    {
      ...stepCommon,
      id: "qn-step4",
      type: "send_survey",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: "\n \n How did you come across Quicknode?",
        type: "buttons",
        options: [
          { emoji: "🐣", id: "twitter", label: "Twitter" },
          { emoji: "🔎", id: "google", label: "Google" },
          { emoji: "📣", id: "press", label: "Press" },
          { emoji: "👥", id: "friend", label: "Friend/Work" },
        ],
      },
      transitions: [
        {
          targetStepId: "qn-step4-twitter",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step4.messageId}}",
              buttonId: "twitter",
            },
          },
        },
        {
          targetStepId: "qn-step4-google",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step4.messageId}}",
              buttonId: "google",
            },
          },
        },
        {
          targetStepId: "qn-step4-press",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step4.messageId}}",
              buttonId: "press",
            },
          },
        },
        {
          targetStepId: "qn-step4-friend",
          when: {
            userResponse: {
              type: "button",
              userId: "{{user.id}}",
              messageId: "{{qn-step4.messageId}}",
              buttonId: "friend",
            },
          },
        },
      ],
    },
    {
      ...stepCommon,
      id: "qn-step4-twitter",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: "Thanks for letting us know!",
      },
      transitions: [{ targetStepId: "qn-step5" }],
    },
    {
      ...stepCommon,
      id: "qn-step4-google",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message:
          "Amazing!\n\nIf you aren’t already following us, you can follow us here https://twitter.com/QuickNode",
      },
      transitions: [{ targetStepId: "qn-step5" }],
    },
    {
      ...stepCommon,
      id: "qn-step4-press",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message:
          "Amazing!\n\nIf you aren’t already following us, you can follow us here https://twitter.com/QuickNode",
      },
      transitions: [{ targetStepId: "qn-step5" }],
    },
    {
      ...stepCommon,
      id: "qn-step4-friend",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message:
          "Amazing!\n\nIf you aren’t already following us, you can follow us here https://twitter.com/QuickNode.",
      },
      transitions: [{ targetStepId: "qn-step5" }],
    },
    {
      ...stepCommon,
      id: "qn-step5",
      type: "edit_roles",
      configs: {
        userIds: ["{{user.id}}"],
        addRoles: ["Verified"],
      },
      transitions: [{ targetStepId: "qn-step6" }],
    },

    {
      ...stepCommon,
      id: "qn-step6",
      type: "send_message",
      configs: {
        channelId: "{{qn-step0.channelId}}",
        message: `\n\n Great! Thanks for being part of our community! You should see all the channels on the left. Please don't hesitate to reach out to us with any questions!\n\nThis channel will be automatically deleted in 10 minutes. If you're looking for general support, please post in the <#685243211706400772> channel.`,
      },
      transitions: [{ targetStepId: "qn-cancel-deletion" }],
    },
    {
      id: `qn-cancel-deletion`,
      type: "cancel_tasks",
      configs: {
        invocationIds: [`{{invocationIds.qn-delete}}`],
      },
      transitions: [{ targetStepId: `qn-step7` }],
    },
    {
      ...stepCommon,
      id: "qn-step7",
      type: "delete_channel",
      isGoal: true,
      configs: {
        delaySeconds: 600,
        channelId: "{{qn-step0.channelId}}",
      },
      transitions: [],
    },
  ],
};

export { quicknodeProdTrigger as trigger, quicknodeProdCategory as categories };
